import React, { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { useLang } from "@/lib/i18n";
import { fetchInfoLine } from "@/lib/api";

// Bilingual fallback used when the live info-line feed has no messages.
const FALLBACK = [
  { ru: "Tagdada — самый быстрый и удобный способ найти недвижимость", en: "Tagdada is the best & fastest way to find a property" },
  { ru: "Реальная, полная и прозрачная информация об объектах.", en: "Real, full & transparent property information." },
];

const ROTATE_MS = 5000;
const FADE_MS = 500;

export const AnnouncementBanner = () => {
  const { lang } = useLang();
  const { data } = useQuery({
    queryKey: ["info-line"],
    queryFn: fetchInfoLine,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
  });

  const apiMsgs = (data?.messages || []).filter(Boolean);
  const messages = apiMsgs.length ? apiMsgs : FALLBACK.map((m) => m[lang]);

  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    setIndex(0);
  }, [messages.length]);

  useEffect(() => {
    if (messages.length < 2) return;
    const id = setInterval(() => {
      setVisible(false);
      setTimeout(() => {
        setIndex((i) => (i + 1) % messages.length);
        setVisible(true);
      }, FADE_MS);
    }, ROTATE_MS);
    return () => clearInterval(id);
  }, [messages.length]);

  const current = messages[index % messages.length] || "";

  return (
    <div
      data-testid="announcement-banner"
      className="bg-[#F3E8FF] border-b border-purple-200 text-[#6D28D9] text-sm text-center py-2 px-4 font-medium"
    >
      <span
        data-testid="announcement-text"
        style={{ transition: `opacity ${FADE_MS}ms ease-in-out` }}
        className={visible ? "opacity-100" : "opacity-0"}
      >
        {current}
      </span>
    </div>
  );
};
